import React from 'react';
import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useReducedMotion } from 'framer-motion';

export interface SceneRenderProps {
  isMobile: boolean;
  shouldReduceMotion: boolean;
}

interface SceneBaseProps {
  children: (props: SceneRenderProps) => React.ReactNode;
  /** Override z-index (default: 0) */
  zIndex?: number;
  /** Additional sx styles */
  sx?: SxProps<Theme>;
}

export const SceneBase = React.memo(function SceneBase({
  children,
  zIndex = 0,
  sx,
}: SceneBaseProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const prefersReducedMotion = useReducedMotion();

  return (
    <Box
      aria-hidden="true"
      role="presentation"
      sx={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex,
        willChange: prefersReducedMotion ? 'auto' : 'transform',
        ...sx,
      }}
    >
      {children({ isMobile, shouldReduceMotion: !!prefersReducedMotion })}
    </Box>
  );
});
